import { useRef, useEffect } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';

export const useServerSideTextFilter = (dataIndex, filters, setFilters) => {
  const searchRef = useRef(null);

  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, visible }) => {
      useEffect(() => {
        if (visible && searchRef.current) {
          setTimeout(() => searchRef.current.focus(), 100);
        }

        // Sync selectedKeys with filters when filter dropdown opens
        if (visible) {
          const currentValue = filters[dataIndex] ?? '';
          setSelectedKeys(currentValue ? [currentValue] : []);
        }
      }, [visible]);

      return (
        <div style={{ padding: 8 }}>
          <Input
            ref={searchRef}
            value={selectedKeys[0]}
            onChange={(e) => {
              const val = e.target.value;
              setSelectedKeys(val ? [val] : []);
            }}
            onPressEnter={() => {
              const newValue = selectedKeys[0] || '';
              const newFilters = { ...filters, [dataIndex]: newValue };
              setFilters(newFilters);
              confirm({ closeDropdown: true });
            }}
            style={{ width: 250 }}
            allowClear
          />
        </div>
      );
    },
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    filteredValue: filters[dataIndex] ? [filters[dataIndex]] : null,
    onFilterClear: () => {
      const updated = { ...filters };
      delete updated[dataIndex];
      setFilters(updated);
    },
  };
};
